export default {
  error: {
    pieceSmartInvalidLines: 'Invalid format on line(s) {lines}; each line must contain four numbers: length, width, height, pieces',
    networkError: 'Network connection failed',
    requestFailed: 'Request failed',
    paramError: 'Invalid request parameters',
    loginExpired: 'Session expired, please log in again',
    noPermission: 'You do not have permission to perform this action',
    noPageAccess: 'You do not have access to any pages, please contact the administrator',
    notFound: 'Requested resource not found',
    concurrencyConflict: 'Data has been modified by another user, please refresh and retry',
    serverError: 'Internal server error',
    unknown: 'Unknown error',
    timeout: 'Request timed out, please retry',
    loadCustomerListFailed: 'Failed to load customer list',
    loadDictFailed: 'Failed to load dictionary data',
    loadUserListFailed: 'Failed to load user list',
    loadRoleListFailed: 'Failed to load role list',
    loadOrgTreeFailed: 'Failed to load organization tree',
    configUpdateFailed: 'Failed to update configuration',
    resetPasswordFailed: 'Failed to reset password',
    deleteFailed: 'Failed to delete',
    loadDictListFailed: 'Failed to load dictionary list',
    queryFailed: 'Query failed',
    saveFailed: 'Failed to save',
    updateStatusFailed: 'Operation failed',
    batchGenerateFailed: 'Batch generation failed',
    batchPreviewInvalid: 'The batch preview is empty or totals do not match. Check sub agreements and selected dates.',
    getDetailFailed: 'Failed to load detail',
    loadAgreementOrderFailed: 'Failed to load agreement entrust no.',
    loadPermissionTreeFailed: 'Failed to load permission tree',
    loadRolePermissionFailed: 'Failed to load role permissions',
    assignPermissionFailed: 'Failed to assign permissions',
    loadPermissionListFailed: 'Failed to load permission list',
    loadOrgListFailed: 'Failed to load organization list',
    loadOrgStructureTreeFailed: 'Failed to load organization structure tree',
    loadLoginLogFailed: 'Failed to load login logs',
    updateConfigFailed: 'Failed to update configuration',
    loadLockedAccountsFailed: 'Failed to load locked accounts',
    unlockAccountFailed: 'Failed to unlock',
    queryAccountFailed: 'Query failed',
    // cs-workbench/CsWorkbenchView
    searchBizOrderFailed: 'Failed to search business order',
    loadSalesUsersFailed: 'Failed to load sales users',
    loadDetailFailed: 'Failed to load details',
    saveUpdateFailed: 'Failed to update data after save',
    submitFailed: 'Submit failed',
    revertFailed: 'Revert failed',
    bubbleCancelFailed: 'Failed to cancel bubble',
    switchDisplayModeFailed: 'Failed to switch display mode',
    bubbleApplyFailed: 'Failed to apply bubble',
    copyFailed: 'Copy failed',
    locateAfterCreateFailed: 'Failed to locate after creation, please find manually',
    // entry/composables
    hawbCreateFailed: 'Failed to create house air waybill',
    warehouseCancelFailed: 'Failed to cancel warehouse entry',
    matchFailed: 'Failed to match',
    returnToPoolFailed: 'Failed to return to pool',
    loadMawbFailed: 'Failed to load master air waybills',
    // entry/dialogs
    dissolveFailed: 'Failed to dissolve',
    lockValidationFailed: 'Lock validation failed',
    mawbDuplicate: 'MAWB no. already exists, please modify and retry',
    createFailed: 'Create failed',
    updateFailed: 'Update failed',
    generateBizOrderNoFailed: 'Failed to generate business order number',
    // entry/components/CargoModeView
    loadCargoTypeDictFailed: 'Failed to load cargo type dictionary',
    // entry/components/PendingWarehouseZone
    setFailed: 'Setting failed',
    // entry/RouteEntryView
    revokeMawbFailed: 'Failed to revoke MAWB',
    locateFailed: 'Location failed, please search manually',
    locateProductOrderFailed: 'Failed to locate product order',
    getBubbleDetailFailed: 'Failed to get bubble allocation detail',
    warehouseFailed: 'Warehouse entry failed',
    unmatchFailed: 'Failed to unmatch',
    bizOrderNotFound: 'Business order not found',
    // composables/api
    loadListFailed: 'Failed to load list',
    loadTabCountsFailed: 'Failed to load tab counts',
    initSseFailed: 'Failed to initialize real-time notifications',
    disconnectSseFailed: 'Failed to disconnect real-time notifications',
    // V6-P0-4: cross-tab editing lock notice
    entityEditingInOtherTab: '{label} is being edited in another browser tab. Please close that tab or refresh before retrying.',
    entityEditingInOtherTabNoLabel: 'This record is being edited in another browser tab. Please close that tab or refresh before retrying.',
    // entry/components/CenterPanel/MasterOrderItem
    saveMawbFailed: 'Failed to save MAWB',
    // login/Index.vue
    invalidCredentials: 'Invalid username or password',
    accountLocked: 'Account has been locked, please retry later or contact administrator to unlock',
    captchaRequired: 'Please enter captcha',
    captchaFailed: 'Captcha incorrect, please try again',
    redirectFailed: 'Failed to redirect after login, please retry',
    passwordChangeFailed: 'Failed to change password',
  },
  success: {
    pieceSmartParsed: 'Parsed and added {count} row(s)',
    operation: 'Operation succeeded',
    save: 'Saved successfully',
    delete: 'Deleted successfully',
    update: 'Updated successfully',
    created: 'Created successfully',
    logout: 'Logged out',
    loginSuccess: 'Login successful',
    passwordChangedEntering: 'Password changed successfully, entering system',
    passwordChanged: 'Password changed successfully, please log in again',
    passwordChangeFailed: 'Failed to change password',
    languageChanged: 'Language switched',
    bizOrderCompleted: 'Business order marked as completed',
    bizOrderUncompleted: 'Completion revoked, reverted to locked status',
    lockSuccess: 'Locked successfully',
    unlockSuccess: 'Unlocked successfully',
    atdFilled: 'ATD filled successfully',
    ataFilled: 'ATA filled successfully',
    customerDeactivated: 'Deactivated',
    customerActivated: 'Activated',
    userUpdated: 'User updated successfully',
    userCreated: 'User created successfully',
    passwordReset: 'Password has been reset to default',
    userDeleted: 'User deleted',
    userDisabled: 'User disabled',
    userEnabled: 'User enabled',
    forceChangePasswordEnabled: 'Force password change enabled',
    forceChangePasswordDisabled: 'Force password change disabled',
    dictionaryUpdated: 'Dictionary updated successfully',
    dictionaryCreated: 'Dictionary created successfully',
    dictionaryDeleted: 'Dictionary deleted',
    itemUpdated: 'Item updated successfully',
    itemCreated: 'Item created successfully',
    itemDeleted: 'Item deleted',
    agreementOrderDisabled: 'Deactivated',
    agreementOrderEnabled: 'Activated',
    permissionAssigned: 'Permissions assigned',
    configUpdated: 'Configuration updated',
    warehouseDataSaved: 'Warehouse data saved',
    cargoChangeSaved: 'Cargo change saved, relevant route staff have been notified',
    // cs-workbench/CsWorkbenchView
    submitSuccess: 'Submitted successfully',
    revertSuccess: 'Reverted successfully',
    bubbleCancelSuccess: 'Bubble cancelled successfully',
    bubbleApplySuccess: 'Bubble applied successfully',
    copyFromHistorySuccess: 'Copied from history successfully',
    refreshedToLatest: 'Refreshed to latest data',
    switchedToWeightMode: 'Switched to weight-based display',
    switchedToRateMode: 'Switched to rate-based display',
    // entry/composables
    hawbCreated: 'House air waybill created successfully',
    warehouseCancelSuccess: 'Warehouse entry cancelled successfully',
    bizOrderMatched: '{no} matched',
    bizOrderReturnedToPool: '{no} returned to pending pool',
    // entry/dialogs
    productOrderDissolved: 'Product order dissolved',
    productOrderLocked: 'Product order locked',
    diffHandlingSubmitted: 'Difference handling submitted',
    mawbUpdated: 'MAWB updated successfully',
    mawbCreated: 'MAWB created successfully',
    productOrderCreated: 'Product order created successfully',
    // entry/components/PendingWarehouseZone
    salesBaseRateSet: 'Sales base rate set successfully',
    // entry/RouteEntryView
    warehouseSuccess: 'Warehouse entry successful',
    cancelWarehouseSuccess: 'Warehouse entry cancelled successfully',
    unmatchSuccess: 'Unmatched successfully',
    matchSuccess: 'Matched successfully',
    batchMatchSuccess: 'Batch match complete: {count} tickets succeeded',
    batchMatchPartialSuccess: 'Batch match complete: {success} succeeded, {fail} failed',
    deviationAccepted: 'Warehouse data accepted',
    deviationRejected: '{no} unmatched, returned to pending pool',
  },
  warning: {
    exportOrdersSelectFirst: 'Please select the business orders to export first',
    exportOrdersOnlyWarehoused: 'Only warehoused orders can be exported; you can filter by warehouse status',
    warehouseOversoldNonBlocking: 'The pallet exceeds the oversell tolerance. Warehouse entry may continue; please confirm the business risk.',
    warehouseOversoldDetail: 'Projected total gross weight {projected}KG / total gross capacity {quota}KG, above the {threshold}KG limit including {percent}% tolerance',
    pieceSmartEmpty: 'Paste piece details before parsing',
    pieceDimensionIncomplete: 'Complete length, width, height, and pieces for every row',
    dataModified: 'Data has been modified by another user, please refresh and retry',
    loadConfigFailed: 'Failed to load configuration',
    selectSubOrderFirst: 'Please select sub agreement entrust no. to generate',
    selectCycleDayFirst: 'Please select cycle day (weekday / month day)',
    agreementOrderNotSaved: 'Agreement entrust no. not saved yet, cannot batch generate',
    subOrderAutoSaveFailed: 'Sub agreement entrust no. auto save failed, please save manually and retry batch generation',
    noChangeDetected: 'No changes detected',
    loadViewRecordsFailed: 'Failed to load view records',
    loadSurchargeDictFailed: 'Failed to load surcharge type dictionary',
    loadSalesUsersFailed: 'Failed to load sales users',
    operationFailed: 'Operation failed',
    suggestionFailed: 'Search suggestions failed',
    bubbleLowProfit: '⚠️ Very low profit margin after bubble, proceed with caution',
    // entry/composables
    loadPendingBizOrdersFailed: 'Failed to load pending business orders',
    switchTabSelectFailed: 'Failed to switch tab and select product order',
    // entry/dialogs/AddMasterAirWaybillDialog
    selectIssuingAirline: 'Please select issuing airline',
    inputMawbNo: 'Please enter MAWB no.',
    loadMawbDetailFailed: 'Failed to load MAWB detail',
    // entry/dialogs/CreateProductOrderDialog
    getAgreementRemainingFailed: 'Failed to get agreement remaining weight',
    getSubOrderListFailed: 'Failed to get sub agreement list',
    inputProductOrderNo: 'Please enter product order no.',
    selectProductType: 'Please select product type',
    fillFlightAndEtd: 'Please fill flight no., origin, destination and ETD',
    inputTrunkRate: 'Please fill trunk rate',
    palletWeightRequired: 'Pallet chargeable weight must be greater than 0',
    originDestinationRequired: 'Please fill in origin and destination ports',
    transitPortRequired: 'Transit port is required for transit transport modes (transit / air-to-land / multimodal)',
    selectSubOrderForCycle: 'This agreement is cycle-based, please select sub agreement no.',
    agreementQuotaFlexibleWarning: 'The agreement quota is insufficient or already oversold. You may continue after confirming the deviation is acceptable.',
    uldQuotaSaveWarning: 'This entry uses {requested} pallet(s) of {type}, while {remaining} pallet(s) remain under the agreement. Saving will create an oversell.',
    agreementWeightSaveWarning: 'This entry uses {requested} KG, while {remaining} KG remains under the agreement. Saving will create an oversell.',
    agreementOversellConfirmTitle: 'Confirm Agreement Oversell',
    uldQuotaFlexibleWarning: 'ULD {type}: requested {requested}, remaining {remaining}. Continuing is allowed but will create a ULD quota overage.',
    // entry/dialogs/EditProductOrderDialog
    productOrderIdNotFound: 'Product order ID not found',
    // entry/components/PalletInfoSection
    getAgreementRemainingQuotaFailed: 'Failed to get agreement remaining quota',
    exceedAgreementRemaining: '⚠ Exceeds agreement remaining quota',
    // entry/components/MawbLocalCostSection
    loadLocalCostFailed: 'Failed to load local costs',
    // cs-workbench/components/CenterPanel/BizOrderForm/ProfitDashboard
    bubbleWillCauseLoss: '🔴 Bubble will cause a loss!',
    // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
    modifyFailed: 'Modify failed',
    // cs-workbench/dialogs/BizOrderCreateDialog
    customerCodeAlreadyUsed: 'The customer code you entered is already in use, please modify or select an existing customer from the dropdown',
    customerNameAlreadyExists: 'This customer name already exists, please select an existing customer from the dropdown or modify the name',
  },
  confirm: {
    completeBizOrder: 'Confirm marking business order {no} as completed?',
    uncompleteBizOrder: 'Confirm revoking completion of business order {no}? It will revert to locked status.',
    completeTitle: 'Complete Confirmation',
    uncompleteTitle: 'Revoke Completion',
    confirmComplete: 'Confirm Complete',
    confirmUncomplete: 'Confirm Revoke',
    unlockTitle: 'Unlock Confirmation',
    confirmUnlock: 'Confirm Unlock',
    unlockPromptMessage: 'Please enter unlock reason',
    unlockPromptPlaceholder: 'Please enter unlock reason (required)',
    fillAtdTitle: 'Fill ATD (Actual Departure Time)',
    fillAtaTitle: 'Fill ATA (Actual Arrival Time)',
    fillAtdPrompt: 'Confirm filling actual departure time for {flight} ({route})?',
    fillAtaPrompt: 'Confirm filling actual arrival time for {flight} ({route})?',
    confirmFill: 'Confirm Fill',
    deactivateCustomer: 'Confirm deactivating customer "{name}"?',
    deactivateTitle: 'Confirm Deactivate',
    deleteCustomer: 'Confirm deleting customer "{name}"? Customers linked to business orders cannot be deleted.',
    deleteTitle: 'Confirm Delete',
    resetPassword: 'Are you sure to reset password of user "{name}"?',
    resetPasswordTitle: 'Confirm Reset',
    disableUser: 'Are you sure to disable user "{name}"?',
    enableUser: 'Are you sure to enable user "{name}"?',
    disableTitle: 'Confirm Disable',
    enableTitle: 'Confirm Enable',
    deleteUser: 'Are you sure to delete user "{name}"? This action cannot be undone!',
    deleteUserTitle: 'Confirm Delete',
    deleteDictionary: 'Are you sure to delete dictionary "{name}"? This will also delete all its items!',
    deleteDictionaryTitle: 'Confirm Delete',
    deleteItem: 'Are you sure to delete item "{name}"?',
    deleteItemTitle: 'Confirm Delete',
    deleteAgreement: 'Are you sure to delete agreement "{name}"?',
    deleteAgreementTitle: 'Notice',
    deleteAgreementOrder: 'Are you sure to delete this agreement entrust no.?',
    deleteAgreementOrderTitle: 'Notice',
    disableAgreementOrder: 'Deactivate agreement order {name}? Once inactive, it can no longer be selected when creating or editing product orders. Existing links are unaffected.',
    enableAgreementOrder: 'Are you sure to activate agreement {name}?',
    disableAgreementOrderTitle: 'Notice',
    enableAgreementOrderTitle: 'Notice',
    regenerateSubOrdersConfirm: 'Pallet structure changed, re-split sub agreements? Manual adjustments will be overwritten.',
    regenerateSubOrdersTitle: 'Notice',
    batchGenerateConfirm: 'This operation cannot be undone. If you change your mind, you will need to manually delete the generated product orders one by one.',
    batchGenerateProductOrdersTitle: 'Batch Generate Product Orders',
    deleteRole: 'Are you sure to delete this role?',
    deleteRoleTitle: 'Notice',
    deletePermission: 'Are you sure to delete this permission? Its child permissions will also be deleted!',
    deletePermissionTitle: 'Notice',
    deleteOrg: 'Are you sure to delete this organization?',
    deleteOrgTitle: 'Notice',
    unlockAccountConfirm: 'Are you sure to unlock account "{name}"?',
    unlockAccountTitle: 'Confirm Unlock',
    baseRateChangedConfirm: 'Sales base rate has changed, apply current calc results anyway?',
    priceChangedTitle: 'Price Change Notice',
    stillApply: 'Apply Anyway',
    // cs-workbench/CsWorkbenchView
    tipTitle: 'Notice',
    warningTitle: 'Warning',
    confirmSubmitBooking: 'Confirm submitting booking?',
    confirmRevertToDraft: 'Confirm reverting to draft?',
    confirmDeleteBizOrder: 'Confirm deleting this business order?',
    bubbleDeviationPrompt: 'The bubble of actual warehouse data differs significantly from the booking, recalculation is needed.',
    bubbleDeviationReminderTitle: 'Bubble Deviation Notice',
    gotIt: 'OK',
    refreshNow: 'Refresh Now',
    later: 'Later',
    // entry/dialogs
    confirmDissolve: 'Confirm dissolve {no} ({flight} {origin}→{destination})?',
    // entry/components/PendingWarehouseZone
    noSalesBaseRateAlert: 'This business order has no sales base rate, cannot create warehouse order. Please set the base rate first.',
    cannotWarehouseTitle: 'Cannot Create Warehouse Order',
    warehouseDataNotBackfilledConfirm: 'This business order has no actual warehouse data. Booked data will be used. Continue?',
    warehouseDataNotBackfilledTitle: 'Warehouse Data Not Backfilled',
    // entry/RouteEntryView
    deleteMawbConfirm: 'Revoking this MAWB will return the number to the pool for later allocation. Confirm revoke?',
    deleteMawbWithHawbsConfirm: 'This MAWB still contains {count} HAWB(s). Revoking it will cancel their warehouse entry, and the business orders will return to the pending warehouse zone. Confirm revoke?',
    deleteHawbConfirm: 'Are you sure to delete this HAWB?',
    saveFailedTitle: 'Save Failed',
  },
  info: {
    unmatchedNoCost: 'Unmatched, no cost info available',
    unlinkedNoTrunkCost: 'No product order linked, no trunk cost info available',
    editCustomerSegment: 'Edit customer segment',
    noMawbNo: 'MAWB No. not filled',
    noHawb: 'No HAWB',
    noHawbData: 'No HAWB data',
    noMawbClickToAdd: 'No MAWB, click "{button}"',
    noMawbData: 'No MAWB data',
    clickCategoryToViewDetail: 'Click a category to view details',
    pleaseSelectDictionary: 'Please select a dictionary category from the left',
    currentEditing: 'Current: {name} ({code})',
    notSet: 'Not set',
    noDescription: 'No description',
    agreementDetailTitle: 'Agreement Detail - {name}',
    agreementOrderDetailTitle: 'Agreement Entrust No. Detail - {name}',
    noPalletStructure: 'No pallet structure info',
    subOrderListTitle: 'Sub Agreement Entrust No. List (by {cycle})',
    cycleWeekly: 'week',
    cycleBiweekly: 'two weeks',
    cycleSemimonthly: 'half month',
    cycleMonthlyWeek: 'monthly week',
    cycleMonthly: 'month',
    biweeklyDayLabel: 'Week {week} {weekday}',
    forwardCycleDay: 'Day {day}',
    reverseCycleDay: '{day} day(s) from end',
    productOrderOccupyingQuota: 'Product Orders Occupying Agreement Quota',
    noProductOrderOccupyingQuota: 'No product orders occupying this agreement quota',
    operationTimeline: 'Operation Timeline',
    cycleTotalSum: 'Sum of cycle total weights: ',
    cycleTotalMatch: '✓ Matches agreement total weight',
    cycleTotalMismatch: '✗ Does not match agreement total weight (should equal {total} KG)',
    selectedSubOrders: '{count} sub agreements selected',
    batchPreviewTitle: 'Pre-generation allocation preview (overlapping dates share one product while retaining multiple weight shares)',
    batchPreviewSummary: '{count} product orders will be created; allocated {allocated} KG, expected {expected} KG.',
    batchPreviewMatch: '✓ Totals match',
    batchPreviewMismatch: '✗ Totals mismatch; generation blocked',
    noQuotaAllocated: 'No quota allocated',
    selectCycleAndPalletFirst: 'Please select agreement period and fill in pallet detail first',
    selectCycleAndWeightFirst: 'Please select the agreement period and enter the chargeable weight quota first',
    volumeCycleAllocationHint: 'Volume quota is evenly split by cycle in whole kilograms, using 100 KG as the preferred minimum allocation unit. You may adjust it before saving.',
    selectedAgreementId: 'Selected agreement ID: {id}',
    saveAsNewAgreement: 'Will be saved as a new agreement (airline will also be saved)',
    executionMethodLocked: 'Agreement entrust no. is in progress, this setting cannot be changed.',
    executionMethodHint: 'Fill in pallet structure (total) before selecting execution method; switching to cycle mode will auto-split sub agreements',
    agreementAirlineHint: 'Airline is brought out from the selected agreement, you can adjust here (only affects this agreement entrust no.)',
    batchGenerateSuccess: 'Successfully generated {count} product orders',
    batchGenerateCreatedOrderNos: 'Nos.: {nos}',
    batchGenerateSkippedNoMatch: 'Sub agreements with no matching dates: {nos}',
    batchGenerateSkippedOccupied: 'Sub agreements already occupied: {nos}',
    noLockedAccounts: 'No locked accounts',
    accountLockHint: 'After 5 consecutive failed login attempts, the account will be locked for 30 minutes. Administrators can manually unlock locked accounts here.',
    selectPermissionToView: 'Please select a permission from the left to view details',
    chargeWeightRuleTitle: 'Chargeable Weight Rounding Rule',
    chargeWeightRuleHint1: 'Half kg up: IATA TACT standard. Any fraction beyond a whole kg is rounded up to the next 0.5 kg (e.g. 1.01→1.5, 2.5→2.5). System default.',
    chargeWeightRuleHint2: 'Round half up: chargeable weight keeps 2 decimals (legacy calculation).',
    chargeWeightRuleHint3: 'This is a global base config affecting all chargeable weight and profit calculations. Switching the rule only affects subsequent calculations; historical data is not recalculated.',
    serialNumberRuleTitle: 'Serial Number Generation Rules',
    serialNumberRuleFormat: 'Format: Prefix-YYYYMMDD-Sequence, e.g. WTH-20260508-0001',
    serialNumberRuleSequence: 'Sequence starts from 0001 daily, 4 digits, zero-padded',
    serialNumberRuleConcurrency: 'Concurrency safety: The system uses database row-level locks to ensure no duplicate numbers',
    serialNumberRuleNote: 'Note: The number is assigned when clicking New, even if the user does not save, the number will not be reassigned',
    bubbleDeviationTitle: 'Bubble Deviation Detection',
    bubbleDeviationRule1: 'When the bubble-eligible weight of actual warehouse data differs from the booked amount beyond this threshold, the system will prompt to recalculate the bubble quote',
    bubbleDeviationRule2: 'Bubble-eligible = Standard chargeable weight (1:167) - Base chargeable weight (1:bubble ratio)',
    bubbleDeviationRule3: 'Deviation % =｜Actual bubble - Booked bubble｜/ Booked bubble × 100%',
    // cs-workbench/BizOrderCargoSection
    toBeCalculated: 'To be calculated',
    actualWeightHint: 'Actual weight (checking this will sync cargo info from warehouse data)',
    warehouseDataAlreadyEntered: 'Warehouse data already entered. You can modify it in the warehouse data section.',
    pieceDetailEdit: 'Piece Detail (Edit)',
    pieceSmartEntry: 'Smart Entry',
    pieceSmartFormat: 'One cargo type per line in this order: length, width, height, pieces (dimensions in cm). Separators may be spaces, commas, ×, x, X, *, or /.',
    pieceSmartExamples: 'Examples: 120 80 60 10 or 100×60×40×5',
    pieceDetailView: 'Piece Detail (View)',
    // cs-workbench/WarehouseBackfillDrawer
    warehouseBackfillTitle: 'Enter Actual Warehouse Data',
    bookedVsActual: 'Booked vs Actual',
    bookedEstimate: 'Booked Estimate',
    actualWarehouseData: 'Actual Warehouse Data',
    bubbleAmount: 'Bubble',
    // cs-workbench/BizOrderList
    loadingInProgress: 'Loading...',
    noDataInCurrentTab: 'No data in current tab',
    otherTabsHaveRecords: 'Other tabs have {count} records',
    noBizOrders: 'No business orders',
    routeUnviewedGroup: '⏳ Route Unviewed ({count})',
    routeViewedGroup: '👁️ Route Viewed ({count})',
    pendingBackfillGroup: '🔶 Pending Backfill ({count})',
    confirmedActualGroup: '✅ Confirmed Actual ({count})',
    searchEmptyInTab: 'No search results in this tab, please check other tabs',
    searchBizOrderTip: 'Fuzzy search: biz order no. / customer name / MAWB no. (e.g. 999-12345678) / HAWB no.',
    noDataForTab: 'No business orders for {tab}',
    allLoaded: 'All {count} loaded',
    bubbleDeviationWarning: 'Large deviation between actual and booked bubble',
    // cs-workbench/BizOrderForm
    routeViewRecords: 'Route View Records',
    noRecords: 'No records',
    rdlNotFilled: 'RDL not filled',
    pendingUnviewedHint: 'Currently pending booking (route not viewed), all info can be modified',
    pendingViewedHint: 'Route viewed, customer info and income info can be modified; to modify freight/cargo info, click "Cargo Change" button',
    cargoChangeEditingHint: 'Cargo change editing in progress, all route staff who have viewed this business order will be notified after saving',
    cargoChangeEditingHintTracking: 'Cargo change editing in progress, a strong notification will be sent to the route operator after saving',
    toBeMatched: 'To be matched',
    pendingBaseRate: 'Base rate not set',
    // cs-workbench/BizOrderCreateDialog
    bizOrderNoHint: 'Manual input or leave blank for auto-generation',
    customerCodeHint: 'System-filled or manual input',
    suggestedUldTypeHint: 'Auto-derived after submission',
    // cs-workbench/BubbleCalcDialog
    bubbleCalcTitle: '💰 Bubble Quote Calculator',
    basicData: '[Basic Data]',
    dataSourceActual: 'Source: Actual warehouse',
    bubbleConfigSection: '[Bubble Config]',
    calcResultSection: '[Calc Result]',
    bubbleRatioTitle: 'Bubble Ratio',
    bubbleShareRatioTitle: 'Bubble Share Ratio',
    notParticipateBubble: '(not participating in bubble)',
    salesGrossProfitImpact: 'Sales Gross Profit Impact:',
    receivableImpact: 'Receivable Impact:',
    bubbleMeaningless: 'Base chargeable ≥ Standard chargeable, bubble is meaningless',
    bubbleNegativeProfit: '🔴 Negative sales gross profit after bubble!',
    baseRateChangedTitle: 'Sales base rate has changed',
    baseRateChangedDesc: 'Route has updated the sales base rate, current calc results may be inaccurate, suggest reopening',
    recalculate: 'Recalculate',
    // cs-workbench/CsWorkbenchView
    selectBizOrderHint: 'Please select a business order from the left',
    selectBizOrderHintDesc: 'After selection, you can view details, edit info, and manage receivables/payables',
    dataModifiedByOther: 'Data has been modified by another user, latest data has been loaded for you',
    confirmFeeWIP: 'Confirm fee feature is under development',
    notifyCustomerWIP: 'Notify customer feature is under development',
    baseRateUpdatedReminder: 'Route has updated the sales base rate. The displayed gross profit may be inaccurate, please refresh to view the latest data',
    baseRateUpdatedDetail: 'Route has updated the sales base rate:\n{oldRate}/KG → {newRate}/KG\nThe displayed gross profit may be inaccurate, please refresh to view the latest data',
    baseRateSetReminder: 'Route staff has set the sales base rate: {rate}/KG\nThe profit shown may be inaccurate, please refresh to view the latest data',
    // entry/dialogs
    dissolveTitle: 'Dissolve Product Order',
    dissolveEffectsTitle: 'After dissolving:',
    dissolveEffect1: '{count} business order(s) will revert to "Pending (viewed by route)" status',
    dissolveEffect2: 'The association between business order and product order will be removed',
    dissolveEffect3: 'Issued house air waybills will be deleted',
    dissolveEffect4: 'This action is irreversible',
    lockProductOrderTitle: 'Lock Product Order',
    lockEffectsTitle: 'After locking:',
    lockEffect1: 'Associated business orders will be locked synchronously',
    lockEffect2: 'All data can no longer be modified',
    warehouseDataFilled: 'Actual warehouse data has been backfilled',
    warehouseDataNotFilled: 'Actual warehouse data has not been backfilled',
    salesProfitPositive: 'Sales gross profit is positive',
    salesProfitNegative: 'Sales gross profit is negative',
    bizOrderSalesProfitNegative: 'Business order {no} has negative sales gross profit',
    mawbReservedNone: 'No reserved but unused MAWB numbers',
    mawbReservedUnused: 'Reserved but unused MAWB numbers exist',
    airlineWeightDiffTitle: 'Airline Weight Difference Handling',
    warehouseDataSection: 'Warehouse Data (entered at booking)',
    airlineDataSection: 'Airline Data (backfilled by airport terminal)',
    diffAnalysisSection: 'Difference Analysis',
    handlingMethodSection: 'Handling Method',
    amendDesc: 'Amend hawb weight to airline data, charge/refund the difference to customer',
    absorbDesc: 'Difference within 5%, borne by freight forwarder, route profit slightly adjusted',
    disputeDesc: 'Consider airline weighing incorrect, apply for re-weighing or return',
    bizOrderDetailTitle: 'Business Order Detail',
    bizOrderDetailTitleWithNo: 'Business Order Detail - {no}',
    basicInfoTab: 'Basic Info',
    bookedInfo: 'Booked Info',
    specialAttributes: 'Special Attributes',
    pieceDetailTitle: 'Piece Detail',
    hawbDetailTitle: 'HAWB Detail',
    hawbDetailTitleWithNo: 'HAWB Detail - {no}',
    partiesTab: 'Parties',
    bubbleAllocationTab: 'Bubble Allocation',
    loadItemsTab: 'Load Items',
    shipper: 'Shipper',
    consignee: 'Consignee',
    notifyParty: 'Notify Party',
    inheritedFromProductOrder: 'Inherited from Product Order',
    // entry/dialogs/CreateProductOrderDialog
    agreementOrderOptionalSection: 'Agreement Order (Optional)',
    uldTypeAndChargeWeight: 'ULD Type & Chargeable Weight',
    selectSubOrderFirstHint: 'Please select sub agreement no. first to load the pallet structure for that cycle',
    allAgreementUldTypesListed: 'These are all ULD types and weights in this agreement',
    allUldTypesListed: 'All ULD types have been listed',
    agreementPeriodLabel: 'Agreement Period: {start} to {end}',
    agreementUnitPriceLabel: 'Unit Price: {price} {currency}/KG',
    agreementTotalWeightLabel: 'Agreement ULD CW Total: {weight} KG',
    agreementRemainingLabel: 'Remaining: {weight} KG',
    agreementOccupiedByOthers: '(Allocated {weight} KG)',
    noRemainingAgreementUld: 'No agreement ULD remains in this period. You may still add a ULD type and confirm any oversell when saving.',
    noAirlinePalletConfig: 'No available pallet type is configured for this airline. Configure one in Pallet Type Management first.',
    uldPoolTotalFormat: '{weight} KG ({count} ULDs)',
    costPricing: 'Cost Pricing',
    uldCountLabel: 'ULD Count:',
    chargeWeightLabel: 'Charge Wt:',
    addUldType: '+ Add ULD Type',
    subOrderOptionLabel: '{no} ({start} ~ {end}) Remaining {weight} KG{occupied}',
    subOrderOccupied: ' [Occupied]',
    // entry/dialogs/EditProductOrderDialog
    volumeTag: 'Volume',
    bsaTag: 'BSA',
    volumeTagBracket: '[Volume]',
    bsaTagBracket: '[BSA]',
    remainingAllocatableLabel: 'Remaining:',
    uldUnit: 'ULD',
    // entry/components/PanelHeader
    oversold: 'Oversold',
    infoOverview: 'Info Overview',
    alertEtdUrgentWarehouse: 'Urgent: No Warehouse Data',
    alertEtdUrgentBooking: 'Urgent: No Booking',
    alertEtdOverdue: 'ETD Overdue',
    alertDefault: 'Alert',
    // entry/components/Index, BaseInfoSection, PalletInfoSection
    routeWorkbench: 'Route Workbench',
    suggestedPalletAndChargeWeight: 'Suggested Pallet & Charge Weight',
    independentPallet: 'Independent Pallet',
    linkedLabel: 'Linked:',
    linkedAgreementLabel: 'Linked agreement:',
    totalLabel: 'Total:',
    // entry/components/ChangeRequestDrawer
    changeConfirmTitle: 'Change Confirmation',
    rejectChangeTitle: 'Reject Change',
    noPendingChangeRequests: 'No pending change requests',
    bizOrderNoWithId: 'Biz Order #{id}',
    // entry/components/CargoModeView
    smartPackSuggestions: 'Smart Pack Suggestions',
    ticketCount: '{count} tickets',
    pieceCountFormat: '{count} pcs',
    matchToThisSpace: 'Match to this space',
    noPendingBookingBizOrders: 'No pending booking business orders',
    // entry/components/MawbLocalCostSection
    payableDetailRouteCost: 'Payable Detail (Route Cost)',
    // entry/components/MasterOrderItem/HawbDetailDialog
    bizOrderInfo: 'Business Order Info',
    hawbInfo: 'HAWB Info',
    bubbleCalcResult: 'Bubble Calculation Result',
    // entry/components/RightPanel
    dragBackToUnmatch: 'Drag back here to unmatch',
    findCargoBySpace: 'Find Cargo by Space',
    findSpaceByCargo: 'Find Space by Cargo',
    selectedTicketsCount: 'Selected {count} tickets',
    // entry/components/WarehouseConfirmDrawer
    warehouseCreateTitle: 'Warehouse Order Creation',
    bookedCargoData: 'Booked Cargo Data',
    actualWarehouseDataSection: 'Actual Warehouse Data',
    hawbInfoSection: 'HAWB Info',
    relatedMawbTitle: 'Related MAWB',
    unfilledMawbNo: 'Unfilled MAWB ({origin}→{destination})',
    unfilledMawbNoShort: 'Unfilled MAWB',
    loadItemsWithPallet: 'Load Items (Pallet Allocation)',
    costEstimate: 'Cost Estimate',
    entered: 'Entered',
    pendingEntry: 'Pending Entry',
    warehouseDataNotEnteredTip: 'CS has not entered actual warehouse data. Booked data will be used as estimate.',
    addLoadRow: '+ Add Load Row',
    chargeWeightTotalLabel: 'Charge Wt Total:',
    independentCostFormula: 'Independent Cost (Charge Wt × Sales Base Rate)',
    trunkCostFormula: 'Trunk Cost (Charge Wt × Trunk Rate)',
    // entry/components/PendingWarehouseZone
    pendingWarehouseCount: 'Pending Warehouse ({count})',
    notBackfilled: 'Not Backfilled',
    actualPrefix: '✅ Actual:',
    warehouseDataNotBackfilledTip: '⚠️ Warehouse data not backfilled, booking data will be used',
    pendingSet: 'Pending',
    dragBizOrderHere: 'Drag business order here',
    // entry/RouteEntryView
    selectProductOrderHint: 'Please select a product order from the left',
    selectProductOrderHintDesc: 'After selection, you can view details, manage MAWB and HAWB',
    bubbleAllocationDetailTitle: 'Bubble Allocation Detail - {desc}',
    bubbleStep1: 'Step 1: Independent calculation per HAWB',
    bubbleStep2: 'Step 2: Merge chargeable weight and actual total cost',
    bubbleStep3: 'Step 3: Total saving',
    bubbleStep4: 'Step 4: Volume deviation',
    bubbleStep5_6: 'Step 5-6: Saving allocation and final share',
    bubbleTotalWeightSigma: 'Total Wt ΣW',
    bubbleTotalVolumeSigma: 'Total Vol ΣV',
    bubbleTotalBubbleWeight: 'Total Bubble Wt',
    bubbleTotalChargeWeight: 'Total Charge Wt',
    bubbleIndependentCostTotal: 'Independent Cost Total',
    bubbleActualTotalCost: 'Actual Total Cost',
    bubbleTotalSavingFormula: 'Total Saving = Independent Cost Total - Actual Total Cost',
    bubbleDeviationPool: 'Deviation Pool = Σ｜Deviation｜',
    bubbleCalcScenario: 'Calculation Scenario',
    bubbleTrunkRateP: 'Trunk Rate (P)',
    bubbleVolumeRatio: 'Volume Conversion Ratio',
    bubbleColWeight: 'Weight W(kg)',
    bubbleColVolume: 'Volume V(CBM)',
    bubbleColVolWeight: 'Vol. Weight(kg)',
    bubbleColChargeWeight: 'Charge Wt(kg)',
    bubbleColIndepCost: 'Indep. Cost(CNY)',
    bubbleColActualVolume: 'Actual Volume V',
    bubbleColAbsDeviation: '｜Deviation｜',
    bubbleColEffRateGross: 'Eff. Rate (Gross)',
    bubbleColBubbleRate: 'Bubble Rate (Charge Wt)',
    bubbleAllowedVolumeFormula: 'Allowed Volume (W×{ratio})',
    warehouseDataChangeReminder: 'Warehouse Data Change Reminder',
    deviationTip: 'Actual warehouse data for business order {no} has changed from booked data',
    bookedPrefix: 'Booked:',
    actualPrefixLabel: 'Actual:',
    deviationDataFormat: 'Weight {w}KG, Volume {v}CBM, Charge Wt {cw}KG',
    selectHandlingMethod: 'Please select handling method:',
    deviationAcceptDesc: 'Accept current warehouse data and continue matching',
    deviationAdjustDesc: 'Accept data but re-evaluate base rate',
    deviationRejectDesc: 'Unmatch, business order returns to pending pool',
    // entry/RouteEntryView cargo change strong reminder dialog
    cargoChangeReminder: 'Cargo Change Reminder',
    cargoChangeTip: 'Cargo info of business order {no} has been modified by customer service, please pay attention',
    cargoChangeFieldCol: 'Changed Item',
    cargoChangeOldCol: 'Old Value',
    cargoChangeNewCol: 'New Value',
    cargoChangeAckDesc: 'Confirm to refresh product order details and display the latest cargo data',
    opsBackfillWIP: 'Ops data backfill feature is under development',
    editHawbWIP: 'Edit HAWB feature is under development',
    sortWIP: 'Sorting feature is under development',
    approveChangeWIP: 'Approve change feature is under development',
    rejectChangeWIP: 'Reject change feature is under development',
    modifySalesBaseRateHint: 'Please modify the sales base rate on the card',
    // entry/components/RightPanel/MatchModeView
    anchorCurrentProductOrder: 'Anchor current product order',
    // cs-workbench/components/CenterPanel/BizOrderForm/ProfitDashboard
    afterBubble: 'After bubble',
    // entry/components/LeftPanel/ProductOrderList
    noProductOrderForTab: 'No product orders for {tab}',
    // entry/components/LeftPanel/ProductOrderCard badges
    badgeChange: 'Chg',
    badgeAdjust: 'Adj',
    badgeDiff: 'Dif',
    badgeEstimate: 'Est',
    badgeWarehouse: 'Wh',
    badgeRate: 'Rate',
    badgeBubble: 'Bub',
    // entry/components/LeftPanel/ProductOrderCard alerts
    oversoldPercent: 'Oversold {percent}%',
    etdExpired: 'ETD Expired',
    // cs-workbench/components/RightPanel/SmartAssistPanel
    noBizOrderSelected: 'No business order selected',
    noRouteRecommendations: 'No route recommendations',
    matchScorePercent: '{score}% match',
    // entry/components/CenterPanel/MasterOrderItem/HawbCard
    savingFormat: '(Saving ¥{amount})',
    airlineWeightDiffPending: '⚠️ Airline weight diff pending',
    diffResolved: '✅ Diff resolved ({handling})',
    // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
    warehouseDataModified: 'Warehouse data modified',
  },
  // businessOrders/Detail.vue errors
  loadBizOrderDetailFailed: 'Failed to load business order detail',
  loadProfitDataFailed: 'Failed to load profit data',
  firstTierProfitNegative: 'First-tier agent profit is negative, please verify the customer sell rate',
  lockFailed: 'Failed to lock',
  unlockFailed: 'Failed to unlock',
  validate: {
    passwordMismatch: 'The passwords entered do not match',
    passwordRequired: 'Please enter current password',
    newPasswordRequired: 'Please enter new password',
    confirmPasswordRequired: 'Please enter new password again',
    passwordTooShort: 'Password must be at least 6 characters',
    usernameExists: 'Username already exists',
    userNotFound: 'User not found',
    usernameRequired: 'Please enter username',
    passwordRequiredLogin: 'Please enter password',
    passwordMinLength: 'Password must be at least 6 characters',
    captchaRequired: 'Please enter captcha',
    selectAtdTime: 'Please select ATD time',
    selectAtaTime: 'Please select ATA time',
    customerNameRequired: 'Please enter customer name',
    realNameRequired: 'Please enter name',
    roleRequired: 'Please select role',
    userOrgRequired: 'Please select the department this user belongs to',
    dictCodeRequired: 'Please enter dictionary code',
    dictNameRequired: 'Please enter dictionary name',
    itemCodeRequired: 'Please enter item code',
    itemNameRequired: 'Please enter item name',
    agreementNoRequired: 'Please enter agreement no.',
    agreementNoMaxLength: 'Agreement no. cannot exceed 100 characters',
    agreementEntrustNoRequired: 'Please enter agreement entrust no.',
    selectAirlineRequired: 'Please select airline',
    originRequired: 'Please enter origin',
    originPattern: '3 uppercase letters',
    destinationRequired: 'Please enter destination',
    destinationPattern: '3 uppercase letters',
    agreementPeriodRequired: 'Please select agreement period',
    agreementUnitPriceRequired: 'Please enter agreement unit price',
    currencyRequired: 'Please select currency',
    cycleModeRequiresSubOrders: 'Sub agreement list is required in cycle mode',
    cycleTotalWeightMismatch: 'Sum of cycle total weights ({sub} KG) must equal agreement total weight ({total} KG)',
    uldTypeCountMismatch: 'Sum of {type} pallet counts across cycles ({sum}) must equal total ({total})',
    roleCodeRequired: 'Please enter role code',
    roleNameRequired: 'Please enter role name',
    permissionCodeRequired: 'Please enter permission code',
    permissionNameRequired: 'Please enter permission name',
    permissionTypeRequired: 'Please select permission type',
    orgCodeRequired: 'Please enter org code',
    orgNameRequired: 'Please enter org name',
    configValueRequired: 'Value cannot be empty',
    actualWeightRequired: 'Please enter actual weight',
    actualVolumeRequired: 'Please enter actual volume',
    // cs-workbench/BizOrderForm
    customerNameCannotBeEmpty: 'Customer name cannot be empty',
    customerCodeCannotBeEmpty: 'Customer code cannot be empty',
    // cs-workbench/BizOrderCreateDialog
    customerCodeRequired: 'Please enter customer code',
    regionSelectRequired: 'Please select region',
    customerSourceRequired: 'Please select customer source',
    legalEntityRelationRequired: 'Please select legal entity relation',
    salesOwnerRequired: 'Please select sales owner',
    contactNameRequired: 'Please enter contact name',
    contactPhoneRequired: 'Please enter contact phone',
    departureRequired: 'Please enter departure',
    destinationPortRequired: 'Please enter destination',
    transportModeRequired: 'Please select transport mode',
    hawbPrealertDeclaredRequired: 'Please select HAWB prealert declaration',
    taxFlagRequired: 'Please select taxable or duty free',
    shippingTermsRequired: 'Please enter shipping terms',
    serviceItemsRequired: 'Please select service items',
    orderCategoryRequired: 'Please select order category',
    piecesRequired: 'Please enter pieces',
    weightRequired: 'Please enter weight',
    volumeRequired: 'Please enter volume',
    cargoTypeRequired: 'Please select cargo type',
    sellCurrencyRequired: 'Please select sell currency',
    sellRateRequired: 'Please enter sell rate',
    // entry/dialogs
    dissolveReasonRequired: 'Please select dissolve reason',
    // entry/components/ChangeRequestDrawer
    rejectReasonRequired: 'Please enter reject reason',
    // entry/components/WarehouseConfirmDrawer
    selectMawbNo: 'Please select a master air waybill',
    selectUldType: 'Please select a pallet type',
    // entry/components/PendingWarehouseZone
    invalidSalesBaseRate: 'Please enter a valid sales base rate',
  },
  // businessOrders/Index.vue errors
  loadDataFailed: 'Failed to load data',
  loadProductOrderFailed: 'Failed to load product order',
  // productOrderRecord/Index.vue errors
  atdFillFailed: 'Failed to fill ATD',
  ataFillFailed: 'Failed to fill ATA',
}
